import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { withSystem, without } from '../data/content';
export function Comparison() {
  return <section className="bg-petrol px-4 py-9 sm:px-6 sm:py-12" data-id="element-35" data-mp="1g8kmn9gulggz">
      <div className="mx-auto max-w-5xl" data-id="element-36" data-mp="1l6cr12yoiv22">
        <h2 className="text-lg font-extrabold leading-tight text-white sm:text-2xl" data-id="element-37" data-mp="1l5b4a18awk4i">
          Votre prochaine séance peut encore commencer par une page blanche...
        </h2>
        <p className="mt-1 font-display text-base font-extrabold uppercase leading-tight text-gold sm:text-2xl" data-id="element-38" data-mp="1uwp82l7ac63g">
          Ou vous pouvez disposer d’un système professionnel déjà organisé.
        </p>

        <div className="mt-5 grid gap-3 sm:grid-cols-2" data-id="element-39" data-mp="23yeybnpfkyzn">
          <div className="rounded-xl border border-white/20 bg-white/5 p-4" data-id="element-40" data-mp="28xi4jbh5db97">
            <h3 className="text-xs font-extrabold uppercase tracking-widest text-white/80 sm:text-sm" data-id="element-41" data-mp="9jvxrqog95k9">
              Sans Orthophonie Pro™
            </h3>
            <ul className="mt-3 space-y-2" data-id="element-42" data-mp="ejh8eyczf2ct">
              {without.map(item => <li key={item} className="flex gap-2 text-[13px] leading-snug text-cream/80" data-id="element-43" data-mp="1m1qy3ajihmbi">
                  <XIcon aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0 text-cream/50" data-id="element-44" data-mp="1h8xvotbimq2l" />
                  {item}
                </li>)}
            </ul>
          </div>
          <div className="rounded-xl border-2 border-gold bg-white p-4" data-id="element-45" data-mp="18a3qiek4crdf">
            <h3 className="text-xs font-extrabold uppercase tracking-widest text-petrol sm:text-sm" data-id="element-46" data-mp="24zl37dhirdom">
              Avec Orthophonie Pro™
            </h3>
            <ul className="mt-3 space-y-2" data-id="element-47" data-mp="20yhpoxmy1tqk">
              {withSystem.map(item => <li key={item} className="flex gap-2 text-[13px] leading-snug text-graphite" data-id="element-48" data-mp="1vxtxi8mzb6ur">
                  <CheckIcon aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0 text-petrol" data-id="element-49" data-mp="1qyqvkx2apgr0" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}